import AdminNumerolojiMeditations from "@/pages/AdminNumerolojiMeditations";

export default function AdminNumerolojiBreaths() {
  return <AdminNumerolojiMeditations mode="breath" />;
}
